import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="superior-bonus"
export default class extends Controller {
  static targets = ["game", "input"]

  search() {
    var searchString = this.inputTarget.value.toLowerCase();
    this.gameTargets.forEach((game) => {
      const gameName = game.innerText.toLowerCase();
      const radioButton = game.querySelector('input[type="radio"]');

      if (!radioButton) {
        return;
      }

      const isSelected = radioButton.checked;

      if (gameName.includes(searchString) || isSelected) {
        game.classList.remove('hidden');
      } else {
        game.classList.add('hidden');
      }
    });
  }
}
